import { render, staticRenderFns } from "./ModalRFID.vue?vue&type=template&id=5bfe5514&"
import script from "./ModalRFID.vue?vue&type=script&lang=js&"
export * from "./ModalRFID.vue?vue&type=script&lang=js&"
import style0 from "./ModalRFID.vue?vue&type=style&index=0&id=5bfe5514&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports